import {useState, useEffect, useRef, useCallback} from 'react';
import * as R from 'ramda';
import useUnMountedState from '@/hooks/useUnMountedState';

const useAPI = (
  fetcher,
  {throwError = true, pending = false, args = []} = {}
) => {
  const [loading, setLoading] = useState(!pending);
  const [result, setResult] = useState(undefined);
  const [error, setError] = useState(undefined);
  const unmounted = useUnMountedState();
  const lastFnId = useRef(0);

  const trigger = useCallback(
    (...manualArgs) => {
      const actualArgs = manualArgs.length ? manualArgs : args;

      lastFnId.current += 1;
      const fnId = lastFnId.current;

      setError(undefined);
      setLoading(true);

      fetcher(...actualArgs)
        .then(data => {
          if (unmounted.current || fnId !== lastFnId.current) return;
          setResult(data);
          setLoading(false);
        })
        .catch(errorMsg => {
          if (unmounted.current || fnId !== lastFnId.current) return;
          setError(errorMsg);
          setLoading(false);
        });
    },
    [fetcher, ...args]
  );

  useEffect(
    () => {
      if (!pending) {
        trigger();
      }
    },
    [trigger]
  );

  if (throwError && error) {
    throw new Error(R.pathOr('', ['response', 'data', 'error'], error));
  }

  return {result, error, loading, trigger};
};

export default useAPI;
